import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=23341819&scoped=true&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=23341819&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23341819",
  null
  
)

export default component.exports